












import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class Day extends Vue {
  /** Current month */
  @Prop({ required: true })
  public day!: Date;

  /** Selected month */
  @Prop({ required: true })
  public date!: Date;

  @Prop({ required: true })
  public selectedBeginDate!: Date;

  @Prop({ required: true })
  public selectedEndDate!: Date;

  @Prop({ required: true })
  public hoveredEndDate!: Date | null;

  public get today() {
    return this.$moment();
  }

  public get isDisabled() {
    return !this.$moment(this.day).isSame(this.date, "month");
  }

  public get classArray() {
    if (this.isDisabled) return ["is-unselectable"];

    return [
      this.$moment(this.day).isSame(this.date, "month")
        ? "is-selectable"
        : "is-unselectable",
      this.$moment(this.day).isSame(new Date(), "day") ? "is-today " : null,
      this.selectedEndDate &&
      this.$moment(this.day).isSame(this.selectedBeginDate, "day")
        ? "is-selected is-first-selected"
        : null,
      this.selectedEndDate &&
      this.$moment(this.day).isSame(this.selectedEndDate, "day")
        ? "is-selected is-last-selected"
        : null,
      this.$moment(this.day).isAfter(this.selectedBeginDate) &&
      this.$moment(this.day).isBefore(this.selectedEndDate)
        ? "is-selected is-within-selected"
        : null,
      !this.selectedEndDate &&
      this.$moment(this.day).isBefore(this.selectedBeginDate) &&
      this.$moment(this.day).isAfter(this.hoveredEndDate)
        ? "is-within-hovered is-within-hovered-range"
        : null,
      !this.selectedEndDate &&
      this.$moment(this.day).isAfter(this.selectedBeginDate) &&
      this.$moment(this.day).isBefore(this.hoveredEndDate)
        ? "is-within-hovered is-within-hovered-range"
        : null,
      !this.selectedEndDate &&
      this.$moment(this.day).isSame(this.selectedBeginDate, "day")
        ? this.$moment(this.day).isAfter(this.hoveredEndDate)
          ? "is-last-hovered is-within-hovered-range"
          : "is-first-hovered is-within-hovered-range"
        : null,
      !this.selectedEndDate &&
      this.$moment(this.day).isSame(this.hoveredEndDate, "day")
        ? this.$moment(this.day).isAfter(this.selectedBeginDate)
          ? "is-last-hovered is-within-hovered-range"
          : "is-first-hovered is-within-hovered-range"
        : null
    ];
  }

  public onClick() {
    if (this.isDisabled) {
      return;
    }
    this.$emit("day-selected", this.day);
  }

  public onHover() {
    if (this.isDisabled) {
      return;
    }
    this.$emit("day-hovered", this.day);
  }
}
